<template>
<div class="help">
    <a class="icon" @click="show = !show">
        <i class="fas fa-question-circle"></i>
    </a> 
    
    <div v-if="show" class="help-text" v-html="text">
    </div>
</div>
</template>

<style scoped lang="scss">
@import "src/css/vars.scss";

.help-text {
    text-align: center; 
    background-color: $tool-tip; 
    color: white; 
    padding: 5px;
    border-radius: 4px; 
    margin-bottom: 20px;
    // position: absolute;
    // z-index: 999;
}

.help {
    text-align: right;
    position: relative;
}
</style>


<script>
export default {
  name: 'HelpTooltip',
  
  props: [
      'text'
  ],
  data: function () {
    return {
        show: false
    }
  }
}
</script>